<div class="second-step-area">
  <div
    class="content-wrapper wrapper-10"
    [ngClass]="{'wrapper-4': role === 'prestataire'}"
  >
    <form
      class="form-area b-h"
      *ngIf="role === 'prestataire'"
      [formGroup]="registerFormProvider"
    >
      <div>
        <!-- domain section -->
        <div class="input-form-box">
          <ion-label>{{'FORM.LABELS.DOMAIN' | translate}}*</ion-label>
          <button
            class="select-btn barder-red"
            [ngClass]="{'barder-red': submitted && !domainSelected}"
            (click)="openDomain(true)"
          >
            {{domainSelected == true ? selectedDomainName:
            ('FORM.PLACEHOLDER.DOMAIN' | translate )}}
          </button>
          <div *ngIf="submitted && !domainSelected" class="error-message">
            Domaine est obligatoire
          </div>
        </div>
        <!-- speciality section -->
        <div class="input-form-box" *ngIf="isSpeciality">
          <ion-label>spécialité</ion-label>
          <button class="select-btn" (click)="openSpecialteModal(true)">
            {{specialitySelected == true ? selectedSpecialiteName : 'Choisissez
            vos spécialités'}}
          </button>
          <div class="row-speciality-checked">
            <div *ngFor="let selectedItem of selectedSpecialiteList1">
              <span>{{ selectedItem.nom }}</span>
              <button (click)="onDeleteSelectedSpecialite(selectedItem)">
                x
              </button>
            </div>
          </div>
        </div>
        <!-- company name section -->
        <div class="input-form-box">
          <ion-label position="floating"
            >{{'FORM.LABELS.COMPANY_NAME' | translate}}*</ion-label
          >
          <div class="inputForm margin-0">
            <input
              class="text-input barder-red"
              [ngClass]="{'barder-red': submitted && provider['societe'].hasError('required')}"
              formControlName="societe"
              placeholder="{{'FORM.PLACEHOLDER.COMPANY_N' | translate }}"
            />
            <div
              *ngIf="submitted && provider['societe'].hasError('required')"
              class="error-message"
            >
              Nom de société est obligatoire
            </div>
          </div>
        </div>
        <!-- type section -->
        <div class="input-form-box">
          <ion-label>{{'FORM.LABELS.COMPANY' | translate}}*</ion-label>
          <button
            class="select-btn barder-red"
            [ngClass]="{'barder-red': submitted && !companyTypeSelected}"
            (click)="openTypeModal(true)"
          >
            {{companyTypeSelected == true ? selectedTypeName :
            ('FORM.LABELS.COMPANY_TYPE' | translate )}}
          </button>
          <div *ngIf="submitted && !companyTypeSelected" class="error-message">
            Type de société est obligatoire
          </div>
        </div>
        <!-- Doc's section -->
        <div class="input-form-box">
          <ion-label class="doc">Documents</ion-label>
          <div class="upload-file-container">
            <!-- URSSAF -->
            <ion-label
              for="file"
              class="custum-file-upload pending unvalid accepted"
              [ngClass]="{
                unvalid: docs['URSSAF'].status === 'CANCELED',
                pending: docs['URSSAF'].status === 'PENDING',
                accepted: docs['URSSAF'].status === 'ACCEPTED',
                'error-state': submitted && missingDocErrors['URSSAF']
              }"
              (click)="fileInput.click()"
            >
              <button
                class="remove-file-icon"
                (click)="removeFile('URSSAF')"
                [disabled]="docs['URSSAF'].status === 'ACCEPTED'"
              ></button>
              <div class="icon">
                <img
                  [src]="
                    '../../../../assets/icon/' +
                    getDocImage(docs['URSSAF'].status)
                  "
                />
              </div>
              <p class="text">
                {{
                  "PROFILE.PROVIDER.DOCUMENT_PART.FILE_INPUTS_LABELS.URSSAF"
                    | translate
                }}
                <br />
                <span
                  *ngIf="docs['URSSAF'].status === 'PENDING'"
                  style="color: red"
                >
                  {{
                    "PROFILE.PROVIDER.DOCUMENT_PART.FILE_INPUTS_LABELS.WAITING"
                      | translate
                  }}
                </span>
              </p>
              <input
                [disabled]="docs['URSSAF'].status === 'ACCEPTED'"
                id="file"
                type="file"
                #fileInput
                accept="image/jpeg, image/png, application/pdf"
                required
                (change)="processFile($event, 'URSSAF')"
              />
              <div class="error" *ngIf="submitted && missingDocErrors['URSSAF']">
                {{ 'Veuillez téléverser le document URSSAF' }}
              </div>
              <div class="error" *ngIf="fileValidationErrors['URSSAF']">
                {{ fileValidationErrors['URSSAF'] }}
              </div>
            </ion-label>

            <!-- KBIS -->
            <ion-label
              for="file"
              class="custum-file-upload pending unvalid accepted"
              [ngClass]="{
                unvalid: docs['KBIS'].status === 'CANCELED',
                pending: docs['KBIS'].status === 'PENDING',
                accepted: docs['KBIS'].status === 'ACCEPTED',
                'error-state': submitted && missingDocErrors['KBIS']
              }"
              (click)="fileInput1.click()"
            >
              <button
                class="remove-file-icon"
                (click)="removeFile('KBIS')"
                [disabled]="docs['KBIS'].status === 'ACCEPTED'"
              ></button>
              <div class="icon">
                <img
                  [src]="
                    '../../../../assets/icon/' +
                    getDocImage(docs['KBIS'].status)
                  "
                />
              </div>
              <p class="text">
                {{
                  "PROFILE.PROVIDER.DOCUMENT_PART.FILE_INPUTS_LABELS.KBIS"
                    | translate
                }}
                <br />
                <span
                  *ngIf="docs['KBIS'].status === 'PENDING'"
                  style="color: red"
                >
                  {{
                    "PROFILE.PROVIDER.DOCUMENT_PART.FILE_INPUTS_LABELS.WAITING"
                      | translate
                  }}
                </span>
              </p>
              <input
                [disabled]="docs['KBIS'].status === 'ACCEPTED'"
                id="file"
                type="file"
                #fileInput1
                accept=".pdf, image/*"
                required
                (change)="processFile($event, 'KBIS')"
              />
              <div class="error" *ngIf="submitted && missingDocErrors['KBIS']">
                {{ 'Veuillez téléverser le document KBIS' }}
              </div>
              <div class="error" *ngIf="fileValidationErrors['KBIS']">
                {{ fileValidationErrors['KBIS'] }}
              </div>
            </ion-label>

            <!-- votre_photo -->
            <ion-label
              for="file"
              class="custum-file-upload pending unvalid accepted"
              [ngClass]="{
                unvalid: docs['votre_photo'].status === 'CANCELED',
                pending: docs['votre_photo'].status === 'PENDING',
                accepted: docs['votre_photo'].status === 'ACCEPTED',
                'error-state': submitted && missingDocErrors['votre_photo']
              }"
              (click)="fileInput2.click()"
            >
              <button
                class="remove-file-icon"
                (click)="removeFile('votre_photo')"
                [disabled]="docs['votre_photo'].status === 'ACCEPTED'"
              ></button>
              <div class="icon">
                <img
                  [src]="
                    '../../../../assets/icon/' +
                    getDocImage(docs['votre_photo'].status)
                  "
                />
              </div>
              <p class="text">
                {{
                  "PROFILE.PROVIDER.DOCUMENT_PART.FILE_INPUTS_LABELS.PHOTO"
                    | translate
                }}
                <br />
                <span
                  *ngIf="docs['votre_photo'].status === 'PENDING'"
                  style="color: red"
                >
                  {{
                    "PROFILE.PROVIDER.DOCUMENT_PART.FILE_INPUTS_LABELS.WAITING"
                      | translate
                  }}
                </span>
              </p>
              <input
                [disabled]="docs['votre_photo'].status === 'ACCEPTED'"
                id="file"
                type="file"
                #fileInput2
                accept=".pdf, image/*"
                required
                (change)="processFile($event, 'votre_photo')"
              />
              <div class="error" *ngIf="submitted && missingDocErrors['votre_photo']">
                {{ 'Veuillez téléverser votre photo' }}
              </div>
              <div class="error" *ngIf="fileValidationErrors['votre_photo']">
                {{ fileValidationErrors['votre_photo'] }}
              </div>
            </ion-label>

            <!-- Piece_d_identite -->
            <ion-label
              for="file"
              class="custum-file-upload pending unvalid accepted"
              [ngClass]="{
                unvalid: docs['Piece_d_identite'].status === 'CANCELED',
                pending: docs['Piece_d_identite'].status === 'PENDING',
                accepted: docs['Piece_d_identite'].status === 'ACCEPTED',
                'error-state': submitted && missingDocErrors['Piece_d_identite']
              }"
              (click)="fileInput3.click()"
            >
              <button
                class="remove-file-icon"
                (click)="removeFile('Piece_d_identite')"
                [disabled]="docs['Piece_d_identite'].status === 'ACCEPTED'"
              ></button>
              <div class="icon">
                <img
                  [src]="
                    '../../../../assets/icon/' +
                    getDocImage(docs['Piece_d_identite'].status)
                  "
                />
              </div>
              <p class="text">
                {{
                  "PROFILE.PROVIDER.DOCUMENT_PART.FILE_INPUTS_LABELS.CIN"
                    | translate
                }}
                <br />
                <span
                  *ngIf="docs['Piece_d_identite'].status === 'PENDING'"
                  style="color: red"
                >
                  {{
                    "PROFILE.PROVIDER.DOCUMENT_PART.FILE_INPUTS_LABELS.WAITING"
                      | translate
                  }}
                </span>
              </p>
              <input
                [disabled]="docs['Piece_d_identite'].status === 'ACCEPTED'"
                id="file"
                type="file"
                #fileInput3
                accept=".pdf, image/*"
                required
                (change)="processFile($event, 'Piece_d_identite')"
              />
              <div class="error" *ngIf="submitted && missingDocErrors['Piece_d_identite']">
                {{ "Veuillez téléverser la pièce d'identité" }}
              </div>
              <div class="error" *ngIf="fileValidationErrors['Piece_d_identite']">
                {{ fileValidationErrors['Piece_d_identite'] }}
              </div>
            </ion-label>
          </div>
        </div>
        <!-- QUALIFICATIONS SECTION -->
        <div class="input-form-box">
          <ion-label position="floating">
            {{'FORM.LABELS.QUALIFICATIONS' | translate}}</ion-label
          >
        </div>
        <!-- QUALIFICATIONS SECTION -->
        <div class="input-form-box">
          <ion-label class="sky-blue" position="floating"
            >{{'FORM.LABELS.DIPLOMA' | translate}}</ion-label
          >
          <div class="inputForm margin-0">
            <input
              class="text-input"
              formControlName="diploma"
              placeholder="Vos diplômes / certificats"
            />
          </div>
        </div>
        <!-- PROFFESIONNEL EXPERIENCE SECTION-->
        <div class="input-form-box">
          <ion-label class="sky-blue"
            >{{'FORM.LABELS.PROFFESIONNEL_EXPERIENCE' | translate}}</ion-label
          >
          <div class="experience-buttons">
            <button
              [ngClass]="{ 'clicked': selectedExperience === 'ONE_TO_THREE_YEARS' }"
              (click)="selectExperience('ONE_TO_THREE_YEARS')"
            >
              1-3 ans
            </button>
            <button
              [ngClass]="{ 'clicked': selectedExperience === 'THREE_TO_FIVE_YEARS' }"
              (click)="selectExperience('THREE_TO_FIVE_YEARS')"
            >
              3-5 ans
            </button>
            <button
              [ngClass]="{ 'clicked': selectedExperience === 'FIVE_PLUS_YEARS' }"
              (click)="selectExperience('FIVE_PLUS_YEARS')"
            >
              +5 ans
            </button>
            <button
              [ngClass]="{ 'clicked': selectedExperience === 'TEN_PLUS_YEARS' }"
              (click)="selectExperience('TEN_PLUS_YEARS')"
            >
              +10 ans
            </button>
          </div>
        </div>
        <!-- CGV ACCEPTANCE SECTION -->
        <div class="input-form-box">
          <div class="cgv-checkbox-container">
            <label class="cgv-checkbox-label">
              <input
                type="checkbox"
                formControlName="acceptCGV"
                [ngClass]="{'error-checkbox': submitted && provider['acceptCGV'].hasError('required')}"
              />
              <span>
                J'accepte les 
                <a (click)="openCGVModal(true)" class="cgv-link">Conditions Générales de Vente</a>
              </span>
            </label>
            <div
              *ngIf="submitted && provider['acceptCGV'].hasError('required')"
              class="error-message"
            >
              Vous devez accepter les Conditions Générales de Vente pour continuer
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="footer">
    <div class="last-step-btns">
      <button class="btn prev-step-btn" (click)="prev(1)">
        <span> {{'BUTTONS.RETURN' | translate}} </span>
      </button>
      <app-button
        style="width: 179px"
        [innerText]="'BUTTONS.REGISTER_BTN' | translate"
        [disabled]="isLoading"
        [loading]="isLoading"
        (onClick)="submitFormProvider()"
      ></app-button>
    </div>
    <div class="t-group" (click)="goToLogin()">
      {{'REGISTER_PAGE.ALREADY_HAVE_ACCOUNT' | translate}}
      <span class="blue-sky">{{'REGISTER_PAGE.CONNECT' | translate}}</span>
    </div>
  </div>
</div>

<!-- domains modal -->
<ion-modal [initialBreakpoint]="1" [isOpen]="domanModal">
  <ng-template>
    <div class="domain-modal">
      <div class="btn-return-b">
        <button class="return-btn" (click)="assureSelectDomain()"></button>
        <h2>Choisissez votre domaine</h2>
      </div>
      <div *ngFor="let domain of domainList" class="radio">
        <input
          [checked]="isSelectedDomaine(domain.id)"
          [id]="domain.id"
          name="domain"
          [value]="domain.nom"
          type="radio"
        />
        <label
          [for]="domain.id"
          class="radio-label"
          (click)="selectDomain(domain)"
        >
          {{ domain.nom }}
        </label>
      </div>
      <div class="handle-btns">
        <button class="cancle" (click)="openDomain(false)">Annuler</button>
        <button class="finish" (click)="assureSelectDomain()">Terminer</button>
      </div>
    </div>
  </ng-template>
</ion-modal>

<!-- type's modal -->
<ion-modal [initialBreakpoint]="1" [isOpen]="typeModal">
  <ng-template>
    <div class="domain-modal">
      <div class="btn-return-b">
        <button class="return-btn" (click)="assureSelectType()"></button>
        <h2>Choisissez le type de la société</h2>
      </div>
      <div *ngFor="let businessType of businessTypes" class="radio">
        <input
          [checked]="isSelectedType(businessType )"
          [id]="businessType"
          name="domain"
          [value]="businessType"
          type="radio"
        />
        <label
          [for]="businessType"
          class="radio-label"
          (click)="selectType(businessType)"
        >
          {{ typeCompany(businessType) }}
        </label>
      </div>
      <div class="handle-btns">
        <button class="cancle" (click)="openTypeModal(false)">Annuler</button>
        <button class="finish" (click)="assureSelectType()">Terminer</button>
      </div>
    </div>
  </ng-template>
</ion-modal>
<!-- specialite modals -->
<ion-modal [initialBreakpoint]="1" [isOpen]="specialteModal">
  <ng-template>
    <div class="domain-modal">
      <div class="btn-return-b">
        <button class="return-btn" (click)="assureSelectSpecialite()"></button>
        <h2>Choisissez vos spécialités</h2>
      </div>
      <div *ngFor="let speciality of specialityList" class="radio">
        <input
          [checked]="isSelectedSpecialite(speciality)"
          [id]="speciality.id"
          name="specialite"
          [value]="speciality.nom"
          type="checkbox"
        />
        <label
          [for]="speciality.id"
          class="radio-label"
          (click)="selectSpecialite(speciality)  "
        >
          {{ speciality.nom }}
        </label>
      </div>
      <div class="handle-btns">
        <button class="cancle" (click)="openSpecialteModal(false)">
          Annuler
        </button>
        <button class="finish" (click)="assureSelectSpecialite()">
          Terminer
        </button>
      </div>
    </div>
  </ng-template>
</ion-modal>

<!-- CGV Modal -->
<ion-modal [initialBreakpoint]="1" [isOpen]="cgvModal" (didDismiss)="openCGVModal(false)">
  <ng-template>
    <ion-header class="cgv-modal-header">
      <div class="cgv-modal-header__toolbar">
        <div class="cgv-modal-header__toolbar__header">
          <a (click)="openCGVModal(false)" class="cgv-modal-header__back-link"></a>
          <h2 class="cgv-modal-header__toolbar__title">
            {{ 'CGV_PROVIDER.TITLE' | translate }}
          </h2>
        </div>
      </div>
    </ion-header>
    <ion-content class="cgv-modal-content">
      <div class="cgv-modal-logo">
        <app-logo 
          [src]="'../../../../../../assets/icon/logo.png'" 
          [alt]="'App Logo'" 
          [width]="'80px'"
          [height]="'auto'" 
          [showVersion]="false" 
          [enableScale]="true">
        </app-logo>
      </div>
      <div class="cgv-modal-body">
        <p class="cgv-last-update"><strong>{{ 'CGV_PROVIDER.LAST_UPDATE' | translate }}</strong> {{ cgvLastUpdate }}</p>
        
        <h3>{{ 'CGV_PROVIDER.SECTION_1_TITLE' | translate }}</h3>
        <p class="cgv-section-text">
          {{ 'CGV_PROVIDER.SECTION_1_P1' | translate }}
        </p>

        <h3>{{ 'CGV_PROVIDER.SECTION_2_TITLE' | translate }}</h3>
        <p class="cgv-section-text">
          {{ 'CGV_PROVIDER.SECTION_2_P1' | translate }}
        </p>

        <h3>{{ 'CGV_PROVIDER.SECTION_3_TITLE' | translate }}</h3>
        <ul class="cgv-section-list">
          <li>{{ 'CGV_PROVIDER.SECTION_3_LI1' | translate }}</li>
          <li>{{ 'CGV_PROVIDER.SECTION_3_LI2' | translate }}</li>
          <li>{{ 'CGV_PROVIDER.SECTION_3_LI3' | translate }}</li>
          <li>{{ 'CGV_PROVIDER.SECTION_3_LI4' | translate }}</li>
        </ul>

        <h3>{{ 'CGV_PROVIDER.SECTION_4_TITLE' | translate }}</h3>
        <p class="cgv-section-text">
          {{ 'CGV_PROVIDER.SECTION_4_P1' | translate }}
        </p>

        <h3>{{ 'CGV_PROVIDER.SECTION_5_TITLE' | translate }}</h3>
        <p class="cgv-section-text">
          {{ 'CGV_PROVIDER.SECTION_5_P1' | translate }}
        </p>

        <h3>{{ 'CGV_PROVIDER.SECTION_6_TITLE' | translate }}</h3>
        <p class="cgv-section-text">
          {{ 'CGV_PROVIDER.SECTION_6_P1' | translate }}
        </p>

        <h3>{{ 'CGV_PROVIDER.SECTION_7_TITLE' | translate }}</h3>
        <p class="cgv-section-text">
          {{ 'CGV_PROVIDER.SECTION_7_P1' | translate }}
        </p>

        <h3>{{ 'CGV_PROVIDER.SECTION_8_TITLE' | translate }}</h3>
        <p class="cgv-section-text">
          {{ 'CGV_PROVIDER.SECTION_8_P1' | translate }}
        </p>
      </div>
      <div class="cgv-modal-footer">
        <button class="cgv-accept-btn" (click)="registerFormProvider.patchValue({acceptCGV: true}); openCGVModal(false)">
          {{ 'CGV_PROVIDER.ACCEPT_BUTTON' | translate }}
        </button>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>
